import { render, staticRenderFns } from "./ExtendedLayout.vue?vue&type=template&id=21eff12f"
import script from "./ExtendedLayout.vue?vue&type=script&lang=js"
export * from "./ExtendedLayout.vue?vue&type=script&lang=js"
import style0 from "./ExtendedLayout.vue?vue&type=style&index=0&id=21eff12f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports